export default {
  CourseDetail: {
    PreviousLesson: 'Bài trước',
    NextLesson: 'Bài tiếp',
    VideoNotFound: 'Không tìm thấy video.',

    AuthorInformation: 'Thông tin tác giả',
    Teacher: 'Giáo viên',
    Organization: 'Nơi công tác',
    LessonCategory: 'Danh mục bài giảng',
    ExerciseEmpty: 'Không có bài tập'
  }
}
